import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var questionMarkIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Zm22 0c0-5.514-4.486-10-10-10S2 6.486 2 12s4.486 10 10 10 10-4.486 10-10Zm-8.75 5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM12.093 6.047c1.036 0 1.943.339 2.55.955.57.578.866 1.373.855 2.297-.017 1.384-.86 2.292-1.536 3.022-.905.975-.948 1.514-.935 2.178h-2.005c-.006-1.475.02-2.125 1.432-3.468.572-.544 1.024-.974.962-1.821-.057-.805-.73-1.226-1.364-1.226-.71 0-1.538.527-1.538 2.013H8.503c0-2.4 1.41-3.95 3.59-3.95Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { questionMarkIcon as default };
//# sourceMappingURL=questionMarkIcon.js.map
